import AddTemplate from "../_templates/AddTemplate";
import { matchSchema } from "../../../schemas/match.schema";
import { createMatch, listMatches } from "../../../api/matches.api";
import { trackEvent } from "../../../lib/trackEvent";


// T212: wrap createMatch so the activation event fires on successful
// create. Uses once:true so the same operator only logs first_match_created
// once per device — cross-device dedup is handled server-side via the
// EXISTS check on ActivationEvent (the table is append-only so a fresh
// row is harmless, but we save a network call when we can).
async function createMatchWithTracking(payload) {
  const r = await createMatch(payload);
  trackEvent("first_match_created", {
    match_id: r?.data?.id || null,
  }, { once: true, persona: "scorer" });
  return r;
}

// Warn the user before creating a match that already exists for the
// same teams on the same date. Server still enforces uniqueness at the
// DB level — this is just a friendly heads-up so operators don't
// silently double up their schedules.
async function checkDuplicateMatch(values) {
  const date = values.match_date || values.scheduled_at;
  const team1 = values.team1;
  const team2 = values.team2;
  if (!team1 || !team2 || !date) return [];
  const year = String(date).slice(0, 4);
  try {
    const res = await listMatches(1, { year });
    const all = res.data?.results || [];
    const dateStr = String(date).slice(0, 10);
    const hits = all.filter((m) => {
      const md = (m.match_date || m.scheduled_at || "").slice(0, 10);
      if (md !== dateStr) return false;
      const t1 = m.team1?.id || m.team1_id;
      const t2 = m.team2?.id || m.team2_id;
      const pair = [t1, t2].filter(Boolean);
      return pair.includes(team1) && pair.includes(team2);
    });
    return hits.slice(0, 5).map((m) => ({
      id: m.id,
      label: `${m.team1?.name || m.team1_name || "Team 1"} vs ${m.team2?.name || m.team2_name || "Team 2"} on ${dateStr}`,
      url: `/cricket/matches/${m.id}/scorecard`,
    }));
  } catch {
    return [];
  }
}

export default function AddMatch() {
  return (
    <AddTemplate
      title="Add Match"
      schema={matchSchema}
      createFn={createMatchWithTracking}
      duplicateCheckFn={checkDuplicateMatch}
      redirectPath="/cricket/matches"
    />
  );
}
